import klappkarteHoch105x148Override from '@/shared/card-formats/klappkarte-hoch-105x148-override';
import klappkarteQuer1_148x105Override from '@/shared/card-formats/klappkarte-quer-1-148x105-override';
import klappkarteQuer2_148x105Override from '@/shared/card-formats/klappkarte-quer-2-148x105-override';

export default {
  [klappkarteHoch105x148Override.id]: klappkarteHoch105x148Override,
  [klappkarteQuer1_148x105Override.id]: klappkarteQuer1_148x105Override,
  [klappkarteQuer2_148x105Override.id]: klappkarteQuer2_148x105Override,
};